import { gql } from "@/__generated__/gql";

export const LOCATIONS = gql(`
  query Locations(
    $filter: String!
    $first: Int
    $after: String
  ) {
    locationCities(search: $filter, first: $first, after: $after) {
      edges {
        node {
          displayString
          id
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`);
